import React from 'react';
import styled from 'styled-components';

import { IPage } from '../../../types/shared';

import SecondaryButton from '../../atoms/secondary-button/SecondaryButton';

import { DEQ_TYPES } from '../../../utils/deq';
import { getInternalLink } from '../../../utils/generic';

import { UnstyledLI, UnstyledUL } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { LinkListProps } from './LinkList.types';

const LinkList = ({ links, deq, className }: LinkListProps) => (
  <UnstyledUL className={className}>
    {links.map((link, index) => (
      <StyledLI key={index}>
        <SecondaryButton
          textAlign="left"
          label={link.label}
          to={`/${getInternalLink(link.linkedPage as IPage, link.externalUrl)}`}
          leadingIcon={link.leadingIcon}
          icon={link.icon}
          type={link.type}
          deqCustomAttributes={{
            componentType: deq?.componentType || '',
            type: DEQ_TYPES.textLink,
            label: link.label.toLowerCase(),
          }}
        />
      </StyledLI>
    ))}
  </UnstyledUL>
);

const StyledLI = styled(UnstyledLI)`
  margin-bottom: ${Spacings.XS};

  &:last-child {
    margin-bottom: 0;
  }
`;

export default LinkList;
